export enum FeatureFlags {
  CREATIVE_SETS = 'CREATIVE_SETS',
  DEAL_HEALTH_GA = 'DEAL_HEALTH_GA',
  DEAL_LEVEL_CPM = 'DEAL_LEVEL_CPM',
  DEAL_LINE_STRIP = 'DEAL_LINE_STRIP',
  DIRECT_SALES_PLANNER = 'DIRECT_SALES_PLANNER',
  DISABLED_AVAILABILITY_LOADER = 'DISABLED_AVAILABILITY_LOADER',
  DISABLED_DIRECT_LINE_STATUS = 'DISABLED_DIRECT_LINE_STATUS',
  DV360 = 'DV360',
  EMAIL_NOTIFICATION = 'EMAIL_NOTIFICATION',
  FRAMES_REPORT = 'FRAMES_REPORT',
  PLANNERS_PERMISSIONS = 'PLANNERS_PERMISSIONS',
  NAVIGATION_PERMISSIONS = 'NAVIGATION_PERMISSIONS',
  GOOGLEMAPS = 'GOOGLEMAPS',
  INVENTORY_RESERVATION_GA = 'INVENTORY_RESERVATION_GA',
  INVENTORY_RESERVATION_LABS = 'INVENTORY_RESERVATION_LABS',
  NON_GUARANTEED_EXTENDED_TARGET = 'NON_GUARANTEED_EXTENDED_TARGET',
  OUT_OF_CHARGE = 'OUT_OF_CHARGE',
  OVERRIDE_DEAL_ID = 'OVERRIDE_DEAL_ID',
  PLANNER_NATIVE = 'PLANNER_NATIVE',
  PLANNER_PROG_OVERVIEW = 'PLANNER_PROG_OVERVIEW',
  POP_LIVE_MONITORING_GA = 'POP_LIVE_MONITORING_GA',
  POP_LIVE_MONITORING_LABS = 'POP_LIVE_MONITORING_LABS',
  REVENUE_INSIGHTS_GA = 'YIELD_INSIGHTS_GA',
  REVENUE_INSIGHTS_LABS = 'YIELD_INSIGHTS_LABS',
  SIMPLIFIED_PLANNING = 'SIMPLIFIED_PLANNING',
  VISUAL_UNITS = 'VISUAL_UNITS',
  VISUAL_UNITS_ORDERING = 'VISUAL_UNITS_ORDERING',
  AVAILABILITY_REPORT = 'AVAILABILITY_REPORT',
  PROOF_OF_PLAY_CHINA_GA = 'PROOF_OF_PLAY_CHINA_GA',
  PROOF_OF_PLAY_CHINA_LABS = 'PROOF_OF_PLAY_CHINA_LABS',
  DEAL_HEALTH_CHINA_GA = 'DEAL_HEALTH_CHINA_GA',
  DEAL_HEALTH_CHINA_LABS = 'DEAL_HEALTH_CHINA_LABS',
  DEAL_HEALTH_US_GA = 'DEAL_HEALTH_US_GA',
  DEAL_HEALTH_US_LABS = 'DEAL_HEALTH_US_LABS',
  NON_MEDIA_SERVICES_ACCESS = 'NON_MEDIA_SERVICES_ACCESS',
  QUICK_DELIVERY_STATS = 'QUICK_DELIVERY_STATS',
  MULTI_TARGET_UPLOAD = 'MULTI_TARGET_UPLOAD',
  ONLY_ALLOW_PLANNER = 'ONLY_ALLOW_PLANNER',
  ALLOW_BILLING_RULES = 'ALLOW_BILLING_RULES',
}
